import * as React from 'react';
import classNames from 'classnames';
import Tooltip from '../../../components/Tooltip';
import { __ } from '../../../core/utils';
import TaskRfiIcon from '../../../assets/images/task-rfi-15x15.svg';
import TaskFyiIcon from '../../../assets/images/task-fyi-15x15.svg';
import TaskDecisionIcon from '../../../assets/images/task-decision-15x15.svg';
import TaskTodoIcon from '../../../assets/images/task-todo-15x15.svg';
import TaskMilestoneIcon from '../../../assets/images/task-milestone-15x15.svg';
import TaskIssueIcon from '../../../assets/images/task-issue-15x15.svg';
import TaskGroupIcon from '../../../assets/images/task-group-icon.svg';
import styles from '../../../styles/flyouts/tasks/Relations.scss';

const statusConfig = {
  'not-started': {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.not-started',
    label: 'table.columns.task-status-notstarted-short',
    style: 'notStarted',
  },
  started: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.started',
    label: 'table.columns.task-status-started-short',
    style: 'started',
  },
  finished: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.finished',
    label: 'table.columns.task-status-finished-short',
    style: 'finished',
  },
  closed: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.closed',
    label: 'table.columns.task-status-closed-short',
    style: 'closed',
  },
  reopened: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.reopened',
    label: 'table.columns.task-status-reopened-short',
    style: 'reopened',
  },
  canceled: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.canceled',
    label: 'table.columns.task-status-canceled-short',
    style: 'canceled',
  },
};

const typeConfig = {
  rfi: {
    tooltip:
      'tasks.all-tasks.flyout.related-tasks.request-for-information',
    Icon: TaskRfiIcon,
    style: 'rfiIcon',
  },
  fyi: {
    tooltip:
      'tasks.all-tasks.flyout.related-tasks.find-your-information',
    Icon: TaskFyiIcon,
    style: 'fyiIcon',
  },
  decision: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.decision',
    Icon: TaskDecisionIcon,
    style: 'decisionIcon',
  },
  todo: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.todo',
    Icon: TaskTodoIcon,
    style: 'todoIcon',
  },
  milestone: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.milestone',
    Icon: TaskMilestoneIcon,
    style: 'milestoneIcon',
  },
  issue: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.issue',
    Icon: TaskIssueIcon,
    style: 'issueIcon',
  },
  group: {
    tooltip: 'tasks.all-tasks.flyout.related-tasks.group',
    Icon: TaskGroupIcon,
    style: 'groupIcon',
  },
};

export const TaskStatus = ({ status }) => {
  const config = statusConfig[status];

  if (!config) {
    return null;
  }

  return (
    <Tooltip text={__(config.tooltip)}>
      <span className={classNames(styles.balloon, styles[config.style])}>
        {__(config.label)}
      </span>
    </Tooltip>
  );
};

export const TaskTypeIcon = ({ type }) => {
  const config = typeConfig[type];

  if (!config) {
    return null;
  }

  const Icon = config.Icon;

  return (
    <Tooltip text={__(config.tooltip)}>
      <Icon className={styles[config.style]} />
    </Tooltip>
  );
};
